module.exports = __webpack_public_path__ + "img/search.1fbd59b2.png";